import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function MapPinIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <circle
        cx="10"
        cy="7"
        r="4.35"
        stroke="#1E1E1E"
        strokeWidth="1.3"
        fill="none"
      />
      <path
        d="M9.35 17.5C9.35 17.859 9.64101 18.15 10 18.15C10.359 18.15 10.65 17.859 10.65 17.5L9.35 17.5ZM9.35 11L9.35 17.5L10.65 17.5L10.65 11L9.35 11Z"
        fill="#1E1E1E"
      />
    </SvgIcon>
  );
}
